<template>
  <form @submit.prevent="submitHandler">

    <div class="alert alert-danger text-center" v-if="errMsg">
      {{ errMsg }}
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">First name:</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.firstName.required && $v.formData.firstName.$dirty }]"
          placeholder="First name"
          @blur="$v.formData.firstName.$touch()"
          v-model="formData.firstName">
        <div class="invalid-feedback">
          Please, enter client first name.
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">Last name:</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.lastName.required && $v.formData.lastName.$dirty }]"
          placeholder="Last name"
          @blur="$v.formData.lastName.$touch()"
          v-model="formData.lastName">
        <div class="invalid-feedback">
          Please, enter client last name.
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">Email:</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': (!$v.formData.email.required && $v.formData.email.$dirty) || !$v.formData.email.email }]"
          placeholder="Email"
          @blur="$v.formData.email.$touch()"
          v-model="formData.email">
        <div class="invalid-feedback">{{ $v.formData.email.required ? 'Please, enter a valid email.' : 'Please, enter a client email.' }}</div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">Phone:</label>
      <div class="col-sm-10">
        <input type="text"
        class="form-control form-control-sm"
        :class="[{ 'is-invalid': !$v.formData.phone.required && $v.formData.phone.$dirty }]"
        placeholder="Phone"
        @blur="$v.formData.phone.$touch()"
        v-model="formData.phone">
        <div class="invalid-feedback">Please, enter a client phone.</div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">Client ID:</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.clientId.required && $v.formData.clientId.$dirty }]"
          placeholder="Client ID"
          @blur="$v.formData.clientId.$touch()"
          v-model="formData.clientId">
        <div class="invalid-feedback">Please, enter a client ID.</div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">Portfolio ID:</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.portfolioId.required && $v.formData.portfolioId.$dirty }]"
          placeholder="Portfolio ID"
          @blur="$v.formData.portfolioId.$touch()"
          v-model="formData.portfolioId">
        <div class="invalid-feedback">Please, enter an portfolio ID.</div>
      </div>
    </div>


    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">Contract ID:</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.contractId.required && $v.formData.contractId.$dirty }]"
          placeholder="Contract ID"
          @blur="$v.formData.contractId.$touch()"
          v-model="formData.contractId">
        <div class="invalid-feedback">Please, enter an contract ID.</div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">Groups:</label>
      <div class="col-sm-10">
        <ul>
          <li v-for="group in groups">
            <div class="form-check">
              <!-- <input class="form-check-input" type="checkbox" checked :id="group.id"> -->
              <input class="form-check-input" type="radio" name="groupscheckbox" :value="group.id" v-model="formData.cgroups" :id="group.id">
              <label class="form-check-label" :for="group.id">{{ group.name }}</label>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <button type="submit" class="btn btn-lg btn-block btn-success" :disabled="$v.formData.$invalid">Create Client</button>

    <loading :loading="loading"></loading>

  </form>
</template>


<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  props: ['groups'],
  validations: {
    formData: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
      },
      clientId: {
        required,
      },
      portfolioId: {
        required,
      },
      contractId: {
        required,
      },
    },
  },
  data() {
    return {
      formData: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        clientId: null,
        portfolioId: null,
        contractId: null,
        cgroups: [],
      },
      loading: false,
      errMsg: null,
    }
  },
  methods: {
    submitHandler() {
      if (!this.$v.formData.$invalid) {
        this.loading = true
        this.$store.dispatch('createClient', this.formData)
          .then(() => {
            this.$emit('createSuccess')
          })
          .catch(errRes => {
            this.errMsg = errRes.error
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    toggleGroup() {
      this.$store.dispatch('updateGroups', {
        id: this.client.id,
        groups: this.groups,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/forms/CreateClientForm.vue